import styled from '@emotion/styled';
import EditableText from 'components/Kizen/EditableText';

export const StyledEditableText = styled(EditableText)`
  width: 100%;
`;
